fourToldApp.controller("groupListCntrl", function(xmppAuth, esb, userDomain, services, $routeParams, $sce, $location, $scope, $route, $controller, $rootScope, $cookieStore, $cookies, $localStorage, $mdDialog, $window) {
    $scope.user = services.user.getData();
    
    $scope.getGroups = function() {
        $scope.progress = "ok";        
        $scope.references = []; 
        services.groups.groupsServices('bearer ' + $window.localStorage.getItem('access_token1')).list({}, function(response) {
            $scope.progress = undefined;
            if (response.data) {
                if (response.data === undefined) {
                    $scope.dataExists = undefined;
                } else {
                    $scope.dataExists = "data";
                    $scope.groupsData = response.data; 
   
                } 
            }
        }, function(error) {
            $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte tecnico");
        }) 
    }; 

    $scope.getLenderImg = function(item) {
        return $scope.LENDER_IMG_URL + item.lender.entity.id;
    }

    $scope.showAlert = function(msg, title) {
        $scope.progress = undefined;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"))
    };

    $scope.checkEmpty = function(searchType, filterBy) {
        if (filterBy === "" && $scope.searchMade === true) {
            $scope.searchMade = false;
            $scope.search(searchType, filterBy)
        }
    }; 
 
     $scope.showDetails = function(group, currentPage, groupType) {
        $scope.progress="ok";
        $window.sessionStorage.setItem("viewTemplate", "groups");        
        $window.sessionStorage.setItem("members",  JSON.stringify(group.members));
        $window.sessionStorage.setItem("groupTypeId", group.id);
        $window.sessionStorage.setItem("groupId", group.id);
        $window.sessionStorage.setItem("groupName", group.name);
        $window.sessionStorage.setItem("groupTypeId", groupType.id);
        $location.path("/groupDetails");
    }; 
 
    
});
